<template>
  <div class="organizer-container">
    <text-field
      v-model.trim="form.publicName"
      :validator="vs.form.publicName"
      :label="adminText('organizationAll.organization_public_name_e8c828c6', 'Organization public name')"
    />
    <!--    <div class="select-type-field">
      <select-field
        v-model="form.type"
        label="Organization type"
        :validator="vs.form.type"
        :items="organizationTypes"
      />
      <button class="type-info-button" @click="isOrganizationTypeDescriptionModalOpen = true">
        <img src="/assets/info-rounded.svg" alt="info button" />
      </button>
    </div>-->
    <text-field v-model.trim="form.email" :validator="vs.form.email" :label="adminText('organizationAll.email_84add5b2', 'Email')" />
    <div class="organizer-info">
      <logo-field v-model="form.logo" class="logo" />
      <textarea-field
        v-model="form.description"
        :label="adminText('organizationAll.organizer_description_6d58cbdd', 'Organizer description')"
        :validator="vs.form.description"
      />
    </div>
    <section class="online-presence">
      <div class="online-presence__header">
        <h2 class="online-presence__title">{{ adminText('organizationAll.online_presence_88dcca02', 'Online presence') }}</h2>
        <p class="online-presence__description">
          {{ adminText('organizationAll.help_visitors_find_your_organization_all_link_e93af21e', 'Help visitors find your organization. All links are optional and should start with https://.') }}
        </p>
      </div>
      <text-field
        v-model.trim="form.webLink"
        :validator="vs.form.webLink"
        :error-messages="organizationMessages(linkErrorMessages)"
        :label="adminText('organizationAll.website_2e8a57cc', 'Website')"
        :placeholder="adminText('organizationAll.https_your_organization_com_e3d79a5b', 'https://your-organization.com')"
      />
      <div class="online-presence__social-links">
        <text-field
          v-model.trim="form.facebookLink"
          :validator="vs.form.facebookLink"
          :error-messages="organizationMessages(linkErrorMessages)"
          :label="adminText('organizationAll.facebook_82da67b2', 'Facebook')"
          :placeholder="adminText('organizationAll.https_facebook_com_2f1bc204', 'https://facebook.com/...')"
        />
        <text-field
          v-model.trim="form.instagramLink"
          :validator="vs.form.instagramLink"
          :error-messages="organizationMessages(linkErrorMessages)"
          :label="adminText('organizationAll.instagram_5721bbef', 'Instagram')"
          :placeholder="adminText('organizationAll.https_instagram_com_6cbd5520', 'https://instagram.com/...')"
        />
        <text-field
          v-model.trim="form.linkedinLink"
          :validator="vs.form.linkedinLink"
          :error-messages="organizationMessages(linkErrorMessages)"
          :label="adminText('organizationAll.linkedin_6b6390a4', 'LinkedIn')"
          :placeholder="adminText('organizationAll.https_linkedin_com_6cfa87c0', 'https://linkedin.com/...')"
        />
        <text-field
          v-model.trim="form.youtubeLink"
          :validator="vs.form.youtubeLink"
          :error-messages="organizationMessages(linkErrorMessages)"
          :label="adminText('organizationAll.youtube_558865a1', 'YouTube')"
          :placeholder="adminText('organizationAll.https_youtube_com_4e3931c7', 'https://youtube.com/...')"
        />
      </div>
    </section>
    <organization-type-description-modal
      v-if="isOrganizationTypeDescriptionModalOpen"
      @closeModal="isOrganizationTypeDescriptionModalOpen = false"
    />
  </div>
</template>

<script>
import OrganizationLocalization from '@/components/organizations/organization-all-display'

import { OrganizationType } from '@/types'
import { capitalize } from 'lodash'
import OrganizationTypeDescriptionModal from '@/components/organizations/organization-type-description-modal.vue'

export default {
  mixins: [OrganizationLocalization],
  name: 'organization-info-form',
  components: { OrganizationTypeDescriptionModal },
  props: {
    initialValues: {
      type: Object,
      default: () => {},
    },
    vs: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: this.initialValues,
      organizationTypes: Object.values(OrganizationType).map(item =>
        capitalize(item.replace(/_/g, ' ')),
      ),
      linkErrorMessages: {
        httpUrl: 'Enter a full URL, for example https://example.com.',
      },
      isOrganizationTypeDescriptionModalOpen: false,
    }
  },
  computed: {
    OrganizationType() {
      return OrganizationType
    },
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('values', val)
      },
      deep: true,
    },
  },
}
</script>

<style scoped>
.organizer-container {
  display: flex;
  row-gap: 2rem;
  flex-direction: column;
}
.organizer-info {
  display: flex;
  flex-wrap: wrap;
  column-gap: 1.5rem;
}
.logo {
  margin: 0 auto;
}
.online-presence {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-top: 0.5rem;
  border-top: 1px solid #e6e6e6;
}
.online-presence__header {
  margin-bottom: 0;
}
.online-presence__title {
  margin: 0 0 0.375rem;
  color: #ff4c00;
  font-family: 'Raleway';
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 500;
  letter-spacing: -0.03em;
}
.online-presence__description {
  margin: 0;
  color: #979797;
  font-family: 'Source Sans Pro';
  font-size: 1rem;
  line-height: 1.5;
}
.online-presence__social-links {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 1.5rem;
  row-gap: 1.25rem;
}
@media screen and (max-width: 600px) {
  .online-presence__social-links {
    grid-template-columns: 1fr;
  }
}
.select-type-field {
  position: relative;
}
.type-info-button {
  position: absolute;
  right: 2.5rem;
  top: 1rem;
}
</style>
